import styled from '@emotion/styled';
import React, { useContext, useEffect, useState } from 'react';
import Modal from '../Modal/Modal';
import HeaderLogo from '../Header/HeaderLogo';
import { RichTextRenderer } from '../RichTextRenderer';
import { VoucherPopupForm } from '../Forms/VoucherPopupForm';

const StyledVoucherPopup = styled.div``;

function VoucherAccordian({ brandData, banner, content }) {
	const [showModal, setShowModal] = useState(true);

	const toggleModal = () => {
		setShowModal(!showModal);
	};

	return (
		<StyledVoucherPopup>
			<Modal showModal={showModal} modalSize='900px' toggleModal={toggleModal}>
				<HeaderLogo brandData={brandData} />
				<div className='mt-20'>
					{banner && (
						<img
							src={banner}
							alt='Redeem your voucher today'
							className='mw-100 mb-20'
						/>
					)}
					{content?.content && content?.content.length > 0 && (
						<RichTextRenderer
							content={content}
							imageTitle='Redeem your voucher today'
						/>
					)}
				</div>
				<VoucherPopupForm toggleModal={toggleModal} />
				<div className='mt-20'>
					<strong>Don&lsquo;t have your voucher code on hand?</strong> No
					problem -{' '}
					<span
						className='text-red cursor-pointer'
						onClick={() => toggleModal()}
					>
						click here
					</span>{' '}
					to continue.
				</div>
			</Modal>
		</StyledVoucherPopup>
	);
}

export default VoucherAccordian;
